{
  "ingredientUnit": {
    "bag": {
      "plural": "sacos",
      "singular": "saco"
    },
    "branch": {
      "plural": "ramos",
      "singular": "ramo"
    },
    "bunch": {
      "plural": "molhos",
      "singular": "molho"
    },
    "can": {
      "plural": "latas",
      "singular": "lata"
    },
    "centiliter": {
      "plural": "centilitros",
      "singular": "centilitro"
    },
    "clove": {
      "plural": "dentes",
      "singular": "dente"
    },
    "cup": {
      "plural": "copos",
      "singular": "copo"
    },
    "dash": {
      "plural": "fios",
      "singular": "fio"
    },
    "decigram": {
      "plural": "decigramas",
      "singular": "decigrama"
    },
    "deciliter": {
      "plural": "decilitros",
      "singular": "decilitro"
    },
    "drop": {
      "plural": "gotas",
      "singular": "gota"
    },
    "gram": {
      "plural": "gramas",
      "singular": "grama"
    },
    "kilogram": {
      "plural": "quilogramas",
      "singular": "quilograma"
    },
    "liter": {
      "plural": "litros",
      "singular": "litro"
    },
    "milligram": {
      "plural": "miligramas",
      "singular": "miligrama"
    },
    "milliliter": {
      "plural": "mililitros",
      "singular": "mililitro"
    },
    "ounce": {
      "plural": "onças",
      "singular": "onça"
    },
    "package": {
      "plural": "pacotes",
      "singular": "pacote"
    },
    "piece": {
      "plural": "pedaços",
      "singular": "pedaço"
    },
    "pinch": {
      "plural": "pitadas",
      "singular": "pitada"
    },
    "sachet": {
      "plural": "sachês",
      "singular": "sachê"
    },
    "slice": {
      "plural": "fatias",
      "singular": "fatia"
    },
    "tablespoon": {
      "plural": "colheres de sopa",
      "singular": "colher de sopa"
    },
    "teaspoon": {
      "plural": "colheres de chá",
      "singular": "colher de chá"
    }
  },
  "recipe": {
    "tag": {
      "difficulty": {
        "easyToStart": "Sim",
        "label": "Começo fácil",
        "notEasyToStart": "Não",
        "placeholder": "Começo fácil"
      }
    }
  }
}